import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useForm } from "react-hook-form";
import {
    Alert,
    AlertTitle,
    Box,
    Button,
    CircularProgress,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    Stack
} from "@mui/material";
import BuyWithAutoComplete from "./BuyWithAutoComplete";
import MultipleUserSelect from "./MultipleUserSelect";
import { makeStyles } from "@material-ui/core";
import AllOrMultiUserSelect from "../../util/AllOrMultiUserSelect";

const AlertList = ({ alerts, severity, userId }) => {
    const renderAlert = (alert) => {
        if (severity === 'success') {
            return <Alert severity={severity}>For user {userId} successfully bought {alert}</Alert>;
        }
        return <Alert severity={severity}>For user {userId} symbol {alert?.symbol} error: {alert?.errorMessage}</Alert>;
    };

    return alerts ? alerts?.map(renderAlert) : null;
};
const useStyles = makeStyles((theme) => ({
    myAlert: {
        color: "#ffffff",
        backgroundColor: "#000000"
    }
}));
const ManualBuy = ({ user }) => {
    const classes = useStyles();

    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [trigger] = React.useState('BUY');
    const [allOrSelected, setAllOrSelected] = React.useState('ALL');
    const [selectedSymbol, setSelectedSymbol] = useState({});
    const [selectedUsers, setSelectedUsers] = React.useState([]);
    const [tradeResponses, setTradeResponses] = useState([{}]);

    const { register, handleSubmit, formState: { errors } } = useForm()

    const handleChange = (event) => {
        setAllOrSelected(event.target.value);
        // For ALL, users should be empty
        setSelectedUsers([])
    };

    useEffect(() => {
        if (user === undefined || Object.keys(user).length === 0) {
            history.push('/')
        }
    }, [user, history])

    const onSubmit = data => {
        if (allOrSelected === 'SELECTED' && selectedUsers.length === 0) {
            return
        }
        setIsLoading(true)
        const userIds = selectedUsers?.map(user => user?.id?.trim()).join(",");
        console.log(data, 'selectedSymbol:', selectedSymbol, 'selectedUsers:', userIds)
        setErrorMessage("")

        fetch(`/algo-trading/api/admin/manual-trigger?symbol=${encodeURIComponent(selectedSymbol?.symbol)}&trigger=${encodeURIComponent(trigger)}&userIds=${encodeURIComponent(userIds)}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                'Authorization': user.credential,
            }
        }).then(function (response) {
            response.text().then(r => {
                if (response.ok) {
                    console.log('OK', r)
                    const responseBody = JSON.parse(r);
                    setTradeResponses(responseBody)
                    if (responseBody?.statusCode > 300) {
                        setErrorMessage(responseBody?.message)
                        setTradeResponses([{}])
                    }
                } else {
                    setErrorMessage(r)
                    setTradeResponses([{}])
                    console.log('FAIL', r)
                }
            })
        }, function (error) {
            console.log('ERROR', error.message)
            setTradeResponses([{}])
        }).finally(() => setIsLoading(false))
    }


    return (
        <>
            <Grid item xs={12}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid item xs={12}>
                        <Typography variant="h4" gutterBottom component="div">
                            Manual Buy Action
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        {tradeResponses && (tradeResponses?.length > 0) && (
                            tradeResponses?.map((tr, i) => (
                                <div key={i}>
                                    {tr?.status === "SUCCESS" && (<Alert severity={"success"}>{tr?.userId}: {tr?.symbol} {tr?.message}</Alert>)}
                                    {tr?.status === "FAILED" && (<Alert severity={"error"}>{tr?.userId}: {tr?.symbol} {tr?.message}</Alert>)}
                                </div>
                            ))
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        {errorMessage && (<Alert variant="filled" severity="error" className={classes.myAlert}><AlertTitle>Error</AlertTitle>{errorMessage}</Alert>)}
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box component="div" display="flex" flexDirection="column" justifyContent="space-between" m={2}>
                            <Box m={2}>
                                <BuyWithAutoComplete user={user} errors={errors} register={register} setSelectedSymbol={setSelectedSymbol} />
                            </Box>
                            <AllOrMultiUserSelect
                                title="Buy for All/Selected Users"
                                user={user}
                                allOrSelected={allOrSelected}
                                setAllOrSelected={handleChange}
                                selectedUsers={selectedUsers}
                                setSelectedUsers={setSelectedUsers}
                            />
                            <Grid container m={2}>
                                <Grid item lg={3} md={5} sm={3} xs={6}>
                                    <Button variant="contained" type="submit">Submit</Button>
                                </Grid>
                                {isLoading &&
                                    <Grid item>
                                        <CircularProgress />
                                    </Grid>
                                }
                            </Grid>
                        </Box>
                    </Grid>
                </form>
            </Grid>
        </>
    )
}

export default ManualBuy